// extracted by mini-css-extract-plugin
export default {"button":"mybutton_button__n0HfN"};